import { render, staticRenderFns } from "./equity-chose-pop.vue?vue&type=template&id=ec67cd02&scoped=true"
import script from "./equity-chose-pop.vue?vue&type=script&lang=js"
export * from "./equity-chose-pop.vue?vue&type=script&lang=js"
import style0 from "./equity-chose-pop.vue?vue&type=style&index=0&id=ec67cd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec67cd02",
  null
  
)

export default component.exports